import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-408c441a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PlayButtonComponent = _resolveComponent("PlayButtonComponent")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.containerClassList,
    ref: "rootElm",
    style: { minHeight: _ctx.height + '!important' }
  }, [
    (!_ctx.isPosterVisible)
      ? (_openBlock(), _createBlock("iframe", {
          key: 0,
          ref: "frame",
          src: `${_ctx.iframe_url}`,
          frameborder: "0",
          allow: "accelerometer; autoplay; encrypted-media; gyroscope",
          allowfullscreen: "",
          height: _ctx.height,
          style: { height: 'auto !important' }
        }, null, 8, ["src", "height"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PlayButtonComponent, {
      isPosterVisible: _ctx.getisPosterVisible(),
      play: _ctx.clickPoster,
      totalDuration: _ctx.dur
    }, null, 8, ["isPosterVisible", "play", "totalDuration"]),
    (_ctx.isPosterVisible)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "pw-player-poster player-adon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickPoster()))
        }, [
          _createVNode("img", {
            src: _ctx.poster,
            alt: "",
            srcset: ""
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true)
  ], 6))
})